import React, {useState} from "react";
import ModalSelect from "../../../../commons/components/ModalSelect";
import {CHILDREN_NUMBER} from "../../../../commons/constans/children_number";
import RadioChildGender from "../../../../commons/components/RadioChildGender";

const Children = ({
                      listChildren,
                      setListChildren,
                      setTabPage
                  }) => {

    const CURRENT_YEAR = new Date().getFullYear();

    const [modalSelect,setModalSelect] = useState({
        show : false,
        indexListChildren : '',
        age : ''
    });


    const handleModalSelect = (index,age) => {
        setModalSelect({
            ...modalSelect,
            show : !modalSelect.show,
            indexListChildren : index,
            age : age
        })
    }

    const handleClickYear = (year) => {
        let children = [...listChildren];
        children[modalSelect.indexListChildren].age = year;
        setListChildren(children);
        setModalSelect({
            show : false,
            indexListChildren : '',
            age : ''
        })
    }

    const handleChangeGender = (gender,i) => {
        let children = [...listChildren];
        children[i].gender = gender;
        setListChildren(children);
    }

    const handleClickRemoveChildren = (index) => {
        let children = [...listChildren];
        children.splice(index,1);
        setListChildren(children);
    }

    return (
        <div className={'content-information'}>
            <div className="custom-information">
                <label>정보를 입력하고 우리 아이가 좋아하는 </label>
                <label>캐릭터 정보를 스포키즈에서 만나보세요!</label>
            </div>

            {listChildren.map((info,i) => {
                return (
                    <div className="information-child" key={i}>
                        <div className={'d-flex justify-content-between'}>
                            <p className="information-child__no">{CHILDREN_NUMBER[i]}</p>
                          {listChildren.length >= 2 ?  <img
                            className={'information-child__icon'}
                            src="/images/icon_close_black_s.svg"
                            alt=""
                            onClick={()=>handleClickRemoveChildren(i)}
                          /> : ''}

                        </div>
                        <RadioChildGender
                            gender={listChildren[i].gender}
                            handleChange={handleChangeGender}
                            genderIndex={i}
                            showTitle={true}
                        />
                        <div
                            className="information-child__year-of-birth"
                            onClick={()=> handleModalSelect(i,info.age)}
                        >
                            <p className>출생년도</p>
                            <div className="information-child__choose-year-of-birth">
                                <span>{info.age}년</span>
                                <img src="/images/setting/icon_arrowdown.svg" className="information-child__choose-year-of-birth-image"
                                     alt=""/>
                            </div>
                        </div>
                    </div>
                )
            })}


            <div
                className="add-child-infor"
                onClick={()=>{
                    let children = [...listChildren];
                    children.push({
                        id : null,
                        age : CURRENT_YEAR,
                        gender : 'M'
                    })

                    setListChildren(children);
                }}
            >
                <img src="/images/icon_plus-btn.svg" alt="" />
                <label>아이정보 추가하기</label>
            </div>
            <div className="btn-child-infor">
                <button
                    type="button" className="btn btn-block btn-primary btn-img"
                    onClick={()=>{
                        setTabPage('character') //set tab character
                    }}
                    disabled={listChildren.length ? false : true}
                >
                    다음
                </button>
            </div>

            <ModalSelect
                id={"MD7"}
                isOpenModalBottom={modalSelect.show}
                handleClose={handleModalSelect}
                handleClick={handleClickYear}
                age={modalSelect.age}
            />
        </div>
    )
}

export default Children;
